import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useClient } from "../../common/ClientProvider";
import { MemberFollowupService } from "./MemberFollowupService";

interface MemberFollowupServiceProviderProps {
  children: React.ReactNode;
}

export const MemberFollowupServiceContext = React.createContext<
  MemberFollowupService | undefined
>(undefined);

export const MemberFollowupServiceProvider: React.FC<
  MemberFollowupServiceProviderProps
> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { currentClientId } = useClient();

  const service = React.useMemo(() => {
    return new MemberFollowupService(getAccessTokenSilently, currentClientId);
  }, [getAccessTokenSilently, currentClientId]);

  return (
    <MemberFollowupServiceContext.Provider value={service}>
      {children}
    </MemberFollowupServiceContext.Provider>
  );
};

export const useMemberFollowupService = (): MemberFollowupService => {
  const context = React.useContext(MemberFollowupServiceContext);
  if (context === undefined) {
    throw new Error(
      "useMemberFollowupService must be used within a MemberFollowupServiceProvider"
    );
  }
  return context;
};
